module.exports = __webpack_public_path__ + "a60020f89950bf8836e4d806c99b9558.png";